'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactBingmaps = require('./components/ReactBingmaps');

Object.defineProperty(exports, 'ReactBingmaps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReactBingmaps).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }